import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { SKIP_AUTH, SUPPRESS_AUTH_REDIRECTS } from 'app/core/http/http-context';
import { Observable } from 'rxjs';

export type SignupPayload = {
	fullName: string;
	preferredName: string;
	email: string;
	password: string;
	passwordConfirm: string;
	referralSource: 'INDICACAO' | 'REDES_SOCIAIS' | 'PESQUISA_GOOGLE' | 'VETERINARIO' | 'OUTRO';
	referralDetail: string;
	termsAccepted: true;
};

export type VerifyEmailPayload = { email: string; token: string };
export type ResendVerificationPayload = { email: string };
export type ForgotPasswordPayload = { email: string };
export type ResetPasswordPayload = {
	email: string;
	token: string;
	password: string;
	passwordConfirm: string;
};
export type LoginPayload = { email: string; password: string };

export type LoginResponse = { token: string };

export type MeResponse = {
	id: string;
	email: string;
	role: 'user' | 'master' | 'vet';
	full_name: string;
	preferred_name: string;
	phone: string | null;
	theme_color: string | null;
	enabled: number;
	blocked: number;
	deleted: number;
	created_at: string;
	updated_at: string;
};

@Injectable({ providedIn: 'root' })
export class AuthApiService {
	private http = inject(HttpClient);

	signup(payload: SignupPayload): Observable<{ created: true }> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<{ created: true }>(`${environment.api}/auth/signup`, payload, {
			context: ctx
		});
	}

	verifyEmail(payload: VerifyEmailPayload): Observable<{ ok: true }> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<{ ok: true }>(`${environment.api}/auth/verify-email`, payload, {
			context: ctx
		});
	}

	resendVerification(payload: ResendVerificationPayload): Observable<{ ok: true }> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<{ ok: true }>(
			`${environment.api}/auth/resend-verification`,
			payload,
			{ context: ctx }
		);
	}

	forgotPassword(payload: ForgotPasswordPayload): Observable<{ ok: true }> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<{ ok: true }>(`${environment.api}/auth/forgot-password`, payload, {
			context: ctx
		});
	}

	resetPassword(payload: ResetPasswordPayload): Observable<{ ok: true }> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<{ ok: true }>(`${environment.api}/auth/reset-password`, payload, {
			context: ctx
		});
	}

	login(payload: LoginPayload): Observable<LoginResponse> {
		const ctx = new HttpContext().set(SKIP_AUTH, true).set(SUPPRESS_AUTH_REDIRECTS, true);

		return this.http.post<LoginResponse>(`${environment.api}/auth/login`, payload, {
			context: ctx
		});
	}

	me(): Observable<MeResponse> {
		return this.http.get<MeResponse>(`${environment.api}/auth/me`);
	}

	logout(): Observable<{ ok: true }> {
		return this.http.post<{ ok: true }>(`${environment.api}/auth/logout`, {});
	}
}
